<template>
  <v-list
    dense
    nav
  >
    <v-list-item
      v-for="menuItem in items"
      :key="menuItem.name"
    >
      <v-list-item-content>
        <v-btn text class="mt-5" block color="primary" dark
          :to="{ name: menuItem.pathName }"
        >
          <v-icon class="mr-2" color="primary" v-if="menuItem.icon">{{ menuItem.icon }}</v-icon>
          {{ $t(menuItem.name) }}
        </v-btn>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import { mapGetters } from 'vuex';
import menuItems from '../adminMenuItems';

export default {
  mixins: [menuItems],
  computed: {
    ...mapGetters('auth', ['isInRole']),
    items() {
      let result = [];
      if (this.isInRole('Kliente Bestuur')) {
        result = [...result, ...this.clientAdminsMenuItems];
      }
      if (this.isInRole('Area Admins')) {
        result = [...result, ...this.areaAdminsMenuItems];
      }
      if (this.isInRole('Administrators')) {
        result = [...result, ...this.administratorsMenuItems];
      }
      return result;
    },
  },
};
</script>

<style scoped>
.v-list-item__content > a {
  justify-content: left;
}
</style>
